<template>
<div id="cabinet_service" class="clearfix">
    <link href="/static/css/general/style-cabinet-avtoservice.css" rel="stylesheet" />
    <div class="wrapper clearfix">
        Дорогие партнеры!<br>
        В своих личных кабинетах Вы видите заявки на ремонт. Вы можете их принять, указать стоимость работ, уточнить, отказаться от заявки или пообщаться с клиентом в чате.<br>
        Телефон клиента Вы видите только тогда, когда клиент выбрал Ваше СТО.<br>
        Помните, именно клиент выбирает дату и время записи! Если Вы никак не сможете принять его в это время, очень корректно согласуйте с ним новую дату и время.<br>
        Качество Вашей работы влияет на рейтинг и отзывы!<br>
        <br>
        Финансовый отдел выставляет Вам счета 1 раз в месяц за произведенные работы. Пожалуйста, оплачивайте их своевременно чтобы получать максимальное количество заявок<br>
        <br>
        <br>
        Для чего нужно указывать фиксированную стоимость работ?<br>
        Фиксированная стоимость работ привлекает гораздо больше клиентов. Клиент сразу видит адрес Вашего СТО, видит стоимость нужной ему работы и записывается минуя конкурентов и ненужного общения в чате, по телефону и пр.<br>
        Чем больше фиксированных стоимостей Вами указано, тем больше клиентов у Вас будет.<br>
    </div>
    <div class="profiletitle-region clearfix col-xs-120">
        <div class="wrapper clearfix">
            <div class="col-md-120 text-center">
                <h4 class="title"><b>Получайте ещё больше клиентов<br>с агрегатором записи на ремонт<br><img
                        class="logotype" src="/static/img/logo-v-autoservis.svg"></b></h4>
            </div>
        </div>
    </div>
    <div class="profilemain-region clearfix col-xs-120">
        <div class="wrapper clearfix">
            <div class="autoserviceprofile-region col-md-120">
                <div class="profile-title col-md-20">
                    <h4 class="title">Основное</h4>
                </div>
                <div class="profilefirst-row col-md-120">
                    <div class="autoservice-name">
                        <span class="title"><b>Название сервиса</b></span>
                        <div class="field">
                            <input type="text" class="name" placeholder="Введите текст" v-model="service.name">
                        </div>
                    </div>
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/HjAiVEDk6CE" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen style="position: absolute; right: 10%;"></iframe>
                </div>
                <div class="profilehalffirst-row col-md-30">
                    <div class="bonuses-payment">
                        <span class="bonuses"><b>Оплата бонусами <img class="bonusesquestion" @click="bonusFaq = !bonusFaq" v-click-outside="hideBonus"
                                                                      src="/static/img/icon-question-bonuses-payment.svg"></b>
                            <div v-if="bonusFaq" class="bonuses-information bonus -selected"><span class="bonusesinformation">Пользователи любят те СТО, которые принимают бонусы и становятся их клиентами гораздо чаще. Мы дополнительно рекламируем такие СТО</span></div>
                        </span>
                        <div class="bonuses-fields">
                            <input type="checkbox" class="bonusespayment" name="bonusespayment"  v-model="service.property.bonusin">
                            <div class="field -short">
                                <input id="bonuses_payment" type="text"  v-model="service.property.bonus" class="input" placeholder="%">
                            </div>
                        </div>
                    </div>
                    <div class="bonuses-payment">
                        <span class="bonuses"><b>Скидка на день рождения</b>
                        </span>
                        <div class="bonuses-fields">
                            <div class="field -short">
                                <input type="text"  v-model="service.property.birthday" class="input" placeholder="%">
                            </div>
                        </div>
                    </div>
                    <div class="bonuses-payment">
                        <span class="bonuses" style="flex-direction: column;"><b>Комиссия</b>
                            <i style="font-size: 12px;line-height: 12px;font-weight: 0;">Укажите, сколько % Вы готовы оплатить агрегатору от состоявшегося ремонта. Обычно, нам платят 10%.</i>
                        </span>
                        <div class="bonuses-fields">
                            <div class="field -short" v-if="!service.fix">
                                <input type="text"  v-model="service.profit" class="input" placeholder="%">%
                            </div>
                            <div class="field -short" v-else>
                                <input type="text"  v-model="service.fix" class="input" placeholder="%">{{city.valute}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="profilesecond-row col-md-30">
                    <span class="title"><b>Логотип</b></span>
                    <span class="description">не менее 128x128 px</span>

                    <label class="profile-logotype">
                        <img :src="service.property.photo" class="photo" style="max-width: 100%; height: auto;bottom: 0;top: 0;margin: auto;">
                        <input type="file" class="uploadlogo" accept="image/jpeg, image/png" ref="file" v-on:change="handleFileUpload()">
                    </label>
                </div>
                <div class="profilethird-row col-md-120">
                    <span class="title"><b>Телефон</b></span>
                    <div class="field width-100">
                        <input placeholder="Введите текст" type="text" data-inputmask="'mask': ['999999999999', '+9(999) 999-9999', '+999 99-99-9999', '+999 99-999-999', '+99(999)999-99-99']" v-model="service.phone">
                    </div>
                </div>
                <div class="profilethird-row col-md-120">
                    <span class="title"><b>Email</b></span>
                    <div class="field width-100">
                        <input placeholder="Введите текст" type="text" v-model="service.email">
                    </div>
                </div>
                <div class="profilethird-row col-md-120">
                    <span class="title"><b>Адрес</b></span>
                    <div class="field width-100">
                        <input placeholder="Введите текст" type="text" v-model="service.address">
                    </div>
                </div>
                <div class="profilethird-row col-md-120">
                    <span class="title"><b>Описание</b></span>
                    <div class="field width-100">
                        <textarea name="description" class="description" id="" cols="30" rows="10" placeholder="Введите текст" v-model="service.description"></textarea>
                    </div>
                </div>
                <div class="profilesixth-row col-md-120">
                    <span class="title">Критерии</span>
                    <div class="criteria-list">
                        <div :class="[service.property.parking ? 'criteria-section -parking -selected' : 'criteria-section -parking']" @click="service.property.parking = !service.property.parking">
                            <img class="criteria -parking" :src="[service.property.parking ? '/static/img/icon-parking-selected.svg' : '/static/img/icon-parking.svg']">
                            <span class="criteriatext">парковка</span>
                            <input type="checkbox" class="checkbox -parking" v-model="service.property.parking">
                        </div>
                        <div :class="[service.property.tv ? 'criteria-section -tv -selected' : 'criteria-section -tv']" @click="service.property.tv = !service.property.tv">
                            <img class="criteria -tv" :src="[service.property.tv ? '/static/img/icon-tv-selected.svg' : '/static/img/icon-tv.svg']">
                            <span class="criteriatext">TV</span>
                            <input type="checkbox" class="checkbox -tv" v-model="service.property.tv">
                        </div>
                        <div :class="[service.property.coffe ? 'criteria-section --tea-coffee -selected' : 'criteria-section -tea-coffee']" @click="service.property.coffe = !service.property.coffe">
                            <img class="criteria -tea-coffee" :src="[service.property.coffe ? '/static/img/icon-tea-coffee-selected.svg' : '/static/img/icon-tea-coffee.svg']">
                            <span class="criteriatext">чай/кофе</span>
                            <input type="checkbox" class="checkbox -tea-coffee" v-model="service.property.coffe">
                        </div>
                        <div :class="[service.property.rest ? 'criteria-section --rest-room -selected' : 'criteria-section -rest-room']" @click="service.property.rest = !service.property.rest">
                            <img class="criteria -rest-room" :src="[service.property.rest ? '/static/img/icon-rest-room-selected.svg' : '/static/img/icon-rest-room.svg']">
                            <span class="criteriatext">зона отдыха</span>
                            <input type="checkbox" class="checkbox -rest-room" v-model="service.property.rest">
                        </div>
                        <div :class="[service.property.wifi ? 'criteria-section --wi-fi -selected' : 'criteria-section -wi-fi']" @click="service.property.wifi = !service.property.wifi">
                            <img class="criteria -wi-fi" :src="[service.property.wifi ? '/static/img/icon-wi-fi-selected.svg' : '/static/img/icon-wi-fi.svg']">
                            <span class="criteriatext">Wi-Fi</span>
                            <input type="checkbox" class="checkbox -wi-fi" v-model="service.property.wifi">
                        </div>
                        <div :class="[service.property.card ? 'criteria-section -card -selected' : 'criteria-section -card']" @click="service.property.card = !service.property.card">
                            <img class="criteria -card" :src="[service.property.card ? '/static/img/icon-card-selected.svg' : '/static/img/icon-card.svg']">
                            <span class="criteriatext">оплата картой</span>
                            <input type="checkbox" class="checkbox -card"  v-model="service.property.card">
                        </div>
                        <div :class="[service.property.bonusin ? 'criteria-section -gift -selected' : 'criteria-section -gift']" @click="service.property.bonusin = !service.property.bonusin">
                            <img class="criteria -gift" :src="[service.property.bonusin ? '/static/img/icon-gift-selected.svg' : '/static/img/icon-gift.svg']">
                            <span class="criteriatext">приём бонусов</span>
                            <input type="checkbox" class="checkbox -gift"  v-model="service.property.bonusin">
                        </div>
                        <div :class="[service.property.eva ? 'criteria-section -evacuator -selected' : 'criteria-section -evacuator']" @click="service.property.eva = !service.property.eva">
                            <img class="criteria -evacuator" :src="[service.property.eva ? '/static/img/icon-evacuator-selected.svg' : '/static/img/icon-evacuator.svg']">
                            <span class="criteriatext">эвакуатор</span>
                            <input type="checkbox" class="checkbox -evacuator"  v-model="service.property.eva">
                        </div>
                        <div :class="[service.property.dil ? 'criteria-section -prize -selected' : 'criteria-section -prize']" @click="service.property.dil = !service.property.dil">
                            <img class="criteria -prize" :src="[service.property.dil ? '/static/img/icon-prize-selected.svg' : '/static/img/icon-prize.svg']">
                            <span class="criteriatext">авторизованный сервис</span>
                            <input type="checkbox" class="checkbox -prize"  v-model="service.property.dil">
                        </div>
                    </div>
                </div>
            </div>

            <div class="autoservicesavebutton-region col-md-120">
                <button type="button" class="btn btn-primary btn-lg autoservicesavebutton" @click="saveService">СОХРАНИТЬ</button>
            </div>
            <div class="autoserviceoffers-region col-md-120" style="display: none">
                <div class="offerstitle-region col-md-20">
                    <span class="title"><b>Акции</b></span>
                </div>
                <div class="autoserviceoffer-section col-md-120">
                    <div class="offer-name col-md-20">
                        <span class="offername">Масло в подарок</span>
                    </div>
                    <div class="offer-description col-md-40">
                        <span class="offerdescription">При ремонте АКПП типа DSG или S-tronic</span>
                    </div>
                    <div class="offer-image col-md-12">
                        <img class="offer-preview" src="/static/img/profile-video-preview.png">
                    </div>
                    <div class="offer-cancel">
                        <a href="#" class="offercancel"><img class="cancel" src="/static/img/button-cancel.svg"></a>
                    </div>
                </div>
                <div class="autoserviceoffer-section col-md-120">
                    <div class="offer-name col-md-20">
                        <span class="offername">Скидка 200 {{city.valute}}</span>
                    </div>
                    <div class="offer-description col-md-40">
                        <span class="offerdescription">На заменту масла в двигателях типа TFSI</span>
                    </div>
                    <div class="offer-image col-md-12">
                        <img class="offer-preview" src="/static/img/profile-video-preview.png">
                    </div>
                    <div class="offer-cancel">
                        <a href="#" class="offercancel"><img class="cancel" src="/static/img/button-cancel.svg"></a>
                    </div>
                </div>
                <form class="autoserviceaddoffer-region col-md-120">
                    <div class="addoffer-name">
                        <span class="addoffertitle"><b>Заголовок</b></span>
                        <div class="field">
                            <input type="text" class="addoffer name" placeholder="Введите текст" required>
                        </div>
                    </div>
                    <div class="addoffer-description">
                        <span class="addofferdescription"><b>Описание</b></span>
                        <div class="field">
                            <input type="text" class="addoffer description" placeholder="Введите текст" required>
                        </div>
                    </div>
                    <div class="addoffer-image">
                        <span class="addofferimage"><b>Изображение</b></span>
                        <div class="addofferimage-buttons">
                            <label class="upload-plus">
                                <img class="uploadphoto" src="/static/img/upload-input-white.svg">
                                <input type="file" class="uploadphoto">
                            </label>
                        </div>
                    </div>
                </form>
            </div>
            <div class="autoserviceservices-region col-md-120">
                <div class="servicesstitle-region col-md-20">
                    <span class="title"><b>Фиксированные цены</b> <img class="bonusesquestion" @click="fixFaq = !fixFaq" v-click-outside="hideFix"
                                                                      src="/static/img/icon-question-bonuses-payment.svg">
                            <div v-if="fixFaq"  class="bonuses-information fix -selected"><span class="bonusesinformation">Фиксированная цена позволяет мгновенно записаться к Вам на ремонт минуя аукцион, звонки, письма. Напишите цены на свои услуги!</span></div></span>
                </div>
                <div class="autoserviceservice-section col-md-120" v-for="(fixprice, index) in service.fixprices" :key="fixprice.id">
                    <div class="service-name col-md-20">
                        <span class="servicename">{{fixprice.category}}</span>
                    </div>
                    <div class="service-description col-md-40">
                        <span class="servicedescription">{{fixprice.job}}</span>
                    </div>
                    <div class="service-description col-md-60">
                        <span class="servicedescription">{{fixprice.desc}}</span>
                    </div>
                    <div class="service-price col-md-10">
                        <span class="serviceprice">{{fixprice.price}} {{city.valute}}</span>
                    </div>
                    <div class="service-cancel">
                        <a class="servicecancel" @click="deleteFixPrice(index, fixprice.id)"><img class="cancel" src="/static/img/button-cancel.svg"></a>
                    </div>
                </div>
                <div class="autoserviceservice-section col-md-120" v-for="(fixprice, index) in fixprices" :key="fixprice.id">
                    <div class="service-name col-md-20">
                        <span class="servicename">{{fixprice.category}}</span>
                    </div>
                    <div class="service-description col-md-40">
                        <span class="servicedescription">{{fixprice.job}}</span>
                    </div>
                    <div class="service-description col-md-60">
                        <span class="servicedescription">{{fixprice.desc}}</span>
                    </div>
                    <div class="service-price col-md-10">
                        <span class="serviceprice">{{fixprice.price}} {{city.valute}}</span>
                    </div>
                    <div class="service-cancel">
                        <a class="servicecancel" @click="deleteFixPrice(index, fixprice.id)"><img class="cancel" src="/static/img/button-cancel.svg"></a>
                    </div>
                </div>
                <div class="autoserviceaddservice-region col-md-120">
                    <div class="addservice-category">
                        <span class="addservicecategory"><b>Категория</b></span>
                        <div class="field">
                            <select id="cat" class="addservice -category" v-model="fp.cat_id" required></select>
                        </div>
                    </div>
                    <div class="addservice-subcategory">
                        <span class="addservicesubcategory"><b>Подкатегория</b></span>
                        <div class="field">
                            <select id="job" class="addservice -subcategory" v-model="fp.job_id" required></select>
                        </div>
                    </div>
                    <div class="addservice-description">
                        <span class="addservicedescription"><b>Описание</b></span>
                        <div class="field">
                            <input type="text" class="addservice -description" v-model="fp.desc" maxlength="75" placeholder="Введите текст" required>
                        </div>
                    </div>
                    <div class="addservice-price">
                        <span class="addserviceprice"><b>Цена</b></span>
                        <div class="field">
                            <input type="number" class="addservice -price" v-model="fp.price" min="0" required>
                        </div>
                    </div>
                    <div class="addservice-button">
                        <label class="upload-plus">
                            <button type="submit" class="uploadphoto" name="uploadphoto" @click="sendFixPrice"></button>
                        </label>
                    </div>
                </div>
            </div>
            <div class="col-md-120">
                Пройдите по ссылке <router-link :to="'/avtoservis/' + service.id">https://в-автосервис.рф/avtoservis/{{service.id}}</router-link> и посмотрите отзывы о своем СТО.
            </div>
            <div class="autoserviceservices-region col-md-120">
                <div class="servicesstitle-region col-md-20">
                    <span class="title"><b>Направления работы</b></span>
                </div>
                <div class="autoserviceaddservice-region col-md-120">

                    <select id="cats" class="addservice -category" multiple="multiple">
                    </select>
                </div>
            </div>

            <div class="autoservicesavebutton-region col-md-120">
                <button type="button" class="btn btn-primary btn-lg autoservicesavebutton" @click="saveToCat">СОХРАНИТЬ НАПРАВЛЕНИЯ</button>
            </div>
        </div>
    </div>

</div>
</template>

<script>
import axios from '@/router/http'
import $ from 'jquery'
import 'select2'
import Inputmask from 'inputmask'
export default {
  props: ['city', 'user', 'auth', 'service'],
  name: 'index',
  data () {
    return {
      errors: [],
      fixFaq: 0,
      bonusFaq: 0,
      fixprices: [],
      fp: {
        cat_id: null,
        job_id: null,
        desc: null,
        price: null
      },
      file: null,
      fps: [],
      to_cat: [],
      fpLoad: 0
    }
  },
  methods: {
    hideFix () {
      this.fixFaq = 0
    },
    hideBonus () {
      this.bonusFaq = 0
    },
    saveService () {
      if (!this.service.name) alert('Необходимо заполнить наименование')
      else if (!this.service.description) alert('Необходимо заполнить описание')
      else if ((this.service.property.bonusin && !this.service.property.bonus) || (this.service.property.bonusin && this.service.property.bonus === '0') || (this.service.property.bonusin && this.service.property.bonus === '-1')) alert('Вы указали прием бонусов, но не указали процент')
      else {
        var formData = new FormData()
        formData.append('id', this.service.id)
        formData.append('name', this.service.name)
        formData.append('desc', this.service.description)
        formData.append('address', this.service.address)
        formData.append('phone', this.service.phone)
        formData.append('email', this.service.email)
        formData.append('profit', this.service.profit)
        formData.append('fix', this.service.fix)
        formData.append('property', JSON.stringify(this.service.property))
        formData.append('photo', this.file)
        axios.post('https://crm.v-avtoservice.com/list/site-save-service?uid=' + this.user.uid,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        )
      }
      console.log(JSON.stringify(this.service))
    },
    sendFixPrice () {
      if (!this.fp.price) alert('Укажите стоимость фиксированной цены')
      else if (this.fpLoad) alert('Ненадо спамить, заявка обрабатывается')
      else {
        this.fpLoad = 1
        var formData = new FormData()
        formData.append('category', this.fp.cat_id)
        formData.append('job', this.fp.job_id)
        formData.append('desc', this.fp.desc)
        formData.append('price', this.fp.price)
        axios.post('https://crm.v-avtoservice.com/list/site-save-fp?uid=' + this.user.uid,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        ).then(response => {
          if (response.data.id) {
            this.fixprices.push({
              id: response.data.id,
              category: this.fps[this.fp.cat_id],
              job: this.fps[this.fp.job_id],
              desc: this.fp.desc,
              price: this.fp.price
            })
            this.fp = {cat_id: null, job_id: null, desc: null, price: null}
            this.fpLoad = 0
          } else {
            alert('Возникла ошибка, попробуйте еще раз')
          }
        })
      }
    },
    deleteFixPrice (index, id) {
      this.fixprices.splice(index, 1)
      this.service.fixprices.splice(index, 1)
      axios.post('https://crm.v-avtoservice.com/list/site-delete-fp?uid=' + this.user.uid + '&id=' + id)
    },
    handleFileUpload () {
      this.file = this.$refs.file.files[0]
    },
    saveToCat () {
      $.post('https://crm.v-avtoservice.com/list/save-service', {
        name: 'job_list[]',
        value: this.to_cat,
        pk: this.service.id
      }).done(function (json) {
        alert(json.text)
      })
    }
  },
  watch: {
    'service.to_cat' (val) {
      for (let select in val) {
        if ($('#cats').find("option[value='" + select + "']").length) {
          $('#cats').val(select).trigger('change')
        } else {
          var newOption = new Option(val[select], select, true, true)
          $('#cats').append(newOption).trigger('change')
        }
      }
    }
  },
  mounted () {
    var $this = this
    let tocat = this.service.to_cat
    for (let select in tocat) {
      if ($('#cats').find("option[value='" + select + "']").length) {
        $('#cats').val(select).trigger('change')
      } else {
        var newOption = new Option(tocat[select], select, true, true)
        $('#cats').append(newOption).trigger('change')
      }
    }
    $('#cats').select2({
      ajax: {
        url: 'https://crm.v-avtoservice.com/jobs/default/job-list',
        dataType: 'json',
        data: function (params) {
          return {
            search: params.term
          }
        },
        processResults: function (data) {
          return {
            results: $.map(data, function (item, key) {
              var children = []
              for (var k in item.childrens) {
                children.push({id: item.childrens[k].id, text: item.childrens[k].name})
              }
              return {
                text: item.name,
                children: children
              }
            })
          }
        }
      }
    }).change(function (data) {
      console.log($(this).val())
      $this.to_cat = $(this).val()
    })
    $('#cat').select2({
      placeholder: 'Выберите категорию',
      ajax: {
        url: 'https://crm.v-avtoservice.com/list/site-get-cats',
        dataType: 'json',
        data: function (param) {
          param.q = param.term
          return param
        },
        processResults: function (data) {
          return {
            results: $.map(data, function (item) {
              $this.fps[item.id] = item.title
              return {
                text: item.title,
                id: item.id
              }
            })
          }
        }
      }
    }).change(function (data) {
      $this.fp.cat_id = $(this).val()
      $('#job').val(null).trigger('change').prop('disabled', false)
    })

    $('#job').select2({
      placeholder: 'Выберите вид работы',
      ajax: {
        url: 'https://crm.v-avtoservice.com/list/site-get-jobs',
        dataType: 'json',
        data: function (param) {
          if ($this.fp.cat_id) {
            param.parent_id = $this.fp.cat_id
          }
          param.q = param.term
          return param
        },
        processResults: function (data) {
          return {
            results: $.map(data, function (item) {
              $this.fps[item.id] = item.title
              return {
                text: item.title,
                id: item.id
              }
            })
          }
        }
      }
    }).change(function (data) {
      $this.fp.job_id = $(this).val()
    })
    Inputmask().mask(document.querySelectorAll('input'))
  }
}
</script>

<style scoped>
    #select-add-field .select2-container--default .select2-selection--single {
        border: 1px solid #3290d0;
    }

    #select-add-field .select2-container--default .select2-selection--single .select2-selection__rendered {
        color: #3290d0;
    }

    #select-add-field .select2-selection__arrow:before {
        content: '+';
        color: #3290d0;
        display: block;
        width: 30px;
        height: 26px;
        background: #fff;
        padding: 0 0 0 8px;
        line-height: 26px;
        z-index: 111111;
        position: absolute;
        font-size: 24px;
        margin: 6px 0 0 -14px;
        border-left: 1px solid #d4d4d4;
    }
    .profilehalffirst-row .bonuses-payment {
        display: flex;
        flex-direction: column;
    }
    .profilehalffirst-row .bonuses-payment .bonuses {
        display: flex;
        width: 210px;
    }

    .profilehalffirst-row .bonuses-payment .bonuses .bonusesquestion {
        margin-top: 2px;
        margin-left: 5px;
        cursor: pointer;
    }

    .profilefirst-row .autoservice-name {
        max-width: 300px;
        width: 100%;
        margin-right: 30px;
    }

    .profilefirst-row .title {
        margin-bottom: 5px;
    }

    .profilehalffirst-row .bonuses-payment {
        max-width: 140px;
        width: 100%;
    }

    .profilehalffirst-row .bonuses {
        margin-bottom: 5px;
    }

    .profilefirst-row .field {
        max-width: 300px !important;
        width: 100%;
    }

    .profilehalffirst-row .bonuses-payment .bonuses {
        font-weight: 600;
        font-size: 15px;
    }

    .profilehalffirst-row .bonuses-payment .checkbox {
        font-weight: 300;
        font-size: 11px;
        color: #4A80C6;
        margin-left: 20px;
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/cabinet/service/index.vue